// !!! DO NOT dDELETE THIS FILE.n IT'S NEEDED FOR process.env.NODE_ENV === 'test'
export default {};
